import { HTMLAttributes } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Container, Typography } from '@mui/material';
import clsx from 'clsx';

const DEFAULT_IMAGE = 'https://storage.googleapis.com/jove-public-images/website/landing-pages/universal/switch-to-jove-smart-choice-img-1.png';

type CustomerTestimonialProps = HTMLAttributes<HTMLDivElement> & { post?: any };

const CustomerTestimonial = (props: CustomerTestimonialProps) => {
  const { className, post } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box className={clsx('bg-dark-blue w-full py-16', className)}>
      <Box component={Container} className="flex flex-col items-center">
        <Box className={clsx('flex w-full rounded-3xl', isMobileLayout ? 'flex-col gap-6 px-4 py-6' : 'flex-row gap-12 px-12 py-12')}>
          {/* Left Side - Image */}
          <Box className={clsx('flex justify-center', isMobileLayout ? 'w-full' : 'flex-1')}>
            <Box
              component="img"
              src={DEFAULT_IMAGE}
              alt={post?.testimonialName}
              sx={{
                width: '100%',
                height: 'auto',
                borderRadius: '20px',
              }}
            />
          </Box>

          {/* Right Side - Testimonial */}
          <Box className={clsx('flex flex-col justify-center space-y-6', isMobileLayout ? 'w-full' : 'flex-1')}>
            {/* Quote */}
            <Typography variant="h4" className="font-black leading-tight text-white">
              {post?.testimonialQuote}
            </Typography>

            {/* Name and Position */}
            <Box className="flex flex-col space-y-1">
              <Typography variant="h6" className="font-medium text-white">
                {post?.testimonialName}
              </Typography>
              <Typography variant="h6" className="font-black text-white">
                {post?.testimonialPosition}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerTestimonial;
